import { Link, Rating } from "@mui/material";
import { MobileViewCellDataGrid } from "components/MobileViewCellDataGrid/MobileViewCellDataGrid";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { TimeLeft } from "components/DateTime/TimeLeft";
import { ContextMenu } from "components/Menu/ContextMenu";
import { TimeSince } from "components/DateTime/TimeSince";
import { Box } from "@mui/system";

export const enquiryListColumnsS = ({
  handleRowClick,
  handleLink,
  handleEdit,
  handleChangeStatus,
  handleTaskButtonClick,
  curUserId,
}) => [
  {
    accessorKey: "clientName",
    header: "Details",
    cell: ({ row }) => (
      <>
        <MobileViewCellDataGrid
          tableData={[
            {
              label: "Enquiry Id",
              data: (
                <FlexBox justifyContent="space-between">
                  <Link
                    href="#"
                    onClick={() => handleRowClick(row.original)}
                    color="textPrimary"
                  >
                    {row.original.docCode}
                  </Link>
                </FlexBox>
              ),
              action: "",
            },
            {
              label: "Name",
              data: (
                <FlexBox justifyContent="space-between">
                  <Link
                    href="#"
                    onClick={() => handleRowClick(row.original)}
                    color="textPrimary"
                  >
                    {row.original.clientName}
                  </Link>
                </FlexBox>
              ),
              action: "",
            },
            {
              label: "Weightage",
              data: (
                <Rating value={row.original.weightage} size="small" readOnly />
              ),
              action: "",
            },
            {
              label: "Registered",
              data: (
                <>{row.original.status === "REGISTER_PROJECT" ? "Yes" : "No"}</>
              ),
              action: "",
            },
            { label: "Budget", data: row.original.budget, action: "" },
            {
              label: "Tar. Con. Date",
              data: (
                <TimeLeft
                  targetDate={row.original.targetConversionDate}
                  variant="data"
                  fontSize={12}
                />
              ),
              action: "",
            },
            {
              label: "BDC",
              data: (
                <Box whiteSpace={"pre-line"}>
                  {row.original.createdBy}
                  <br />
                  <TimeSince startDate={row.original.createdOn} />
                </Box>
              ),
              action: "",
            },
            {
              label: "City",
              data: (
                <Box whiteSpace={"pre-line"}>{row.original.clientCity}</Box>
              ),
              action: "",
            },
            {
              label: "Delivery Date",
              data: (
                <TimeLeft
                  targetDate={row.original.deliveryDate}
                  variant="data"
                  fontSize={12}
                />
              ),
              action: "",
            },
            {
              label: "Registered",
              data: (
                <Box whiteSpace={"pre-line"}>
                  {row.original.status === "REGISTER_PROJECT" ? "Yes" : "No"}
                </Box>
              ),
              action: "",
            },
            {
              label: "Link",
              data: (
                <ContextMenu
                  handleLinkClick={() => handleLink(row.original.link)}
                  linkLabel="Link"
                  handleMiscAction1={
                    curUserId === row.original.createdById
                      ? () =>
                          handleChangeStatus(
                            "REGISTER_PROJECT",
                            row.original.id
                          )
                      : null
                  }
                  misc1Label="Register Project"
                  handleEditAction={
                    curUserId === row.original.createdById
                      ? () => handleEdit(row.original)
                      : null
                  }
                  editLabel="Edit"
                  handleTaskAction={() => handleTaskButtonClick(row.original)}
                  taskLabel="Create Task"
                />
              ),
              action: "",
            },
          ]}
        />
      </>
    ),
  },
];
